import { useMemo } from "react";
import _ from "lodash";
import { IAccountError } from '../modules/Account/types/accountActions.t';

export const useFormFieldErrors = (formDefinedErrors: {[p: string]: readonly string[]}, formError: IAccountError) => {
    return useMemo(() => {
            const fieldErrors = Object
                .entries(formDefinedErrors)
                .reduce((accum, [field, errors]) => ({
                    ...accum,
                    [field]: typeof formError === 'string' && errors.includes(formError) ? formError : ''
                }), {});
            const allDefinedErrors = _.flatten(Object.values(formDefinedErrors));
            const common = typeof formError !== 'string' || allDefinedErrors.includes(formError) ? '' : formError;
            return { ...fieldErrors, common };
        }, [formDefinedErrors, formError]
    );
}
